import clsx from 'clsx';
import {HTMLAttributes} from 'react';
import {c} from 'ttag';
import {getCurrentYear} from 'utils/date';
import getPreferredLanguage from 'utils/locale';

import {footer, footerLink} from './styles.module.css';

const FooterBasic = ({className, ...rest}: HTMLAttributes<HTMLElement>) => {
    const language = getPreferredLanguage();

    return (
        <footer className={clsx(footer, 'flex p-4', className)} {...rest}>
            <div className="flex flex-1">
                <div className="flex items-center gap-2">
                    <a
                        className={footerLink}
                        href={`https://www.makeleaps.com/${language}/about-us/`}
                        rel="noreferrer"
                        target="_blank"
                    >
                        {c('component').t`About`}
                    </a>
                    <a
                        className={footerLink}
                        href="https://help.makeleaps.jp/ja/"
                        rel="noreferrer"
                        target="_blank"
                    >
                        {c('component').t`Help Center`}
                    </a>
                    <a
                        className={footerLink}
                        href={`https://www.makeleaps.com/${language}/q-a/`}
                        rel="noreferrer"
                        target="_blank"
                    >
                        {c('component').t`Q&A`}
                    </a>
                </div>
                <div className="grid flex-1 content-center pl-5 text-right text-white">
                    © {getCurrentYear()} MakeLeaps
                </div>
            </div>
        </footer>
    );
};
export default FooterBasic;
